var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.15,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.713 9.944 2.244 3.812c.1.168.02.282-.174.247l-2.41-.4-.835 2.252c-.067.181-.205.194-.306.028l-2.152-3.57M2.287 9.944.043 13.756c-.1.168-.02.282.174.247l2.41-.4.836 2.252c.067.182.205.194.305.028l2.153-3.566M13.74 5.63a1.96 1.96 0 0 0-1.259-1.821 1.932 1.932 0 0 0-.422-2.16 2.027 2.027 0 0 0-2.203-.415A1.998 1.998 0 0 0 8 0c-.818 0-1.553.49-1.856 1.234a2.027 2.027 0 0 0-2.204.413 1.932 1.932 0 0 0-.423 2.162 1.96 1.96 0 0 0-1.26 1.82c0 .803.5 1.524 1.26 1.82a1.932 1.932 0 0 0 .423 2.16 2.027 2.027 0 0 0 2.202.415 1.997 1.997 0 0 0 1.856 1.235c.819 0 1.554-.49 1.856-1.235a2.027 2.027 0 0 0 2.203-.415 1.932 1.932 0 0 0 .422-2.16 1.958 1.958 0 0 0 1.262-1.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.87 3.87 7.484 7.192a.544.544 0 0 1-.761 0l-1.235-1.21"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientCertificate);
export default __webpack_public_path__ + "static/media/client-certificate.e175d148.svg";
export { ForwardRef as ReactComponent };